<div fxLayout="column" fxLayoutAlign="space-between" style="height: 90%">
  <mat-nav-list>
    <ng-container *ngFor="let menu of menuList">
      <ng-container *ngTemplateOutlet="menuTemplate; context: menu;">
      </ng-container>
    </ng-container>
  </mat-nav-list>
</div>

<ng-template #menuTemplate
             let-title="title"
             let-link="link"
             let-icon="icon"
             let-svg="svg"
             let-hidden="hidden">
  <a mat-list-item
     *ngIf="!hidden"
     [routerLink]="link"
     (click)="clickMenuItem.emit();">
    <mat-icon *ngIf="icon">{{icon}}</mat-icon>
    <mat-icon *ngIf="svg" [svgIcon]="svg"></mat-icon>
    <span class="nav-menu-text menu-title">{{title}}</span>
  </a>
</ng-template>
